import { loadFavorites, syncFavorites } from '@/stores/favorites';
import { syncPendingSearchCriteria } from '@/stores/searchcriteria';
import { $authReady, $supabaseUser } from '@/stores/supabase';
import { $userProfile, loadUserProfile } from '@/stores/userProfile';
import { supabase } from './client';

let initialized = false;

/**
 * Central auth bootstrap: owns the single `onAuthStateChange` subscription
 * in the bundle and sequences all auth side effects after session restore.
 * Called exactly once from the frontend entry (`src/frontend.ts`).
 */
export function initAuth(): void {
	if ( initialized ) return;
	initialized = true;

	supabase.auth.onAuthStateChange( ( event, session ) => {
		$supabaseUser.set( session?.user ?? null );
		$authReady.set( true );

		// Load the profile only after session restore has delivered a
		// session — never at module import time.
		if (
			( event === 'INITIAL_SESSION' && session?.user ) ||
			event === 'SIGNED_IN'
		) {
			void loadUserProfile();
		}

		// Sync local favorites and pending search profiles when a user logs
		// in, but don't await it
		if ( event === 'SIGNED_IN' && session?.user ) {
			void syncFavorites( session.user.id );
			void syncPendingSearchCriteria();
		}

		// Handle logout by loading local favorites
		if ( event === 'SIGNED_OUT' ) {
			$userProfile.set( null );
			void loadFavorites( null );
		}
	} );
}
